import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { t } from '../../../../modules/infra/i18n';
import SimpleCurrencyInput from '../../../common/SimpleCurrencyInput';

const ChargeAmount = ({ onChange, value, splitPaymentDisabled, disabled }) => (
  <div className="o-flexbox o-flexbox--justify-center">
    <div className="c-heading c-heading--huge u-inline-block u-mr u-pt--">
      {t('register:payment.charge_amount.pay_label')}
    </div>
    <SimpleCurrencyInput
      wrapperClassName={classnames('c-payment-input', { 'is-label': splitPaymentDisabled })}
      placeholder=""
      value={value}
      onInputChange={onChange}
      disabled={disabled}
      addPrefix
      dataAutomationId="input:chargeAmount"
    />
  </div>
);
ChargeAmount.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
  splitPaymentDisabled: PropTypes.bool.isRequired,
};

export default ChargeAmount;
